import { render, staticRenderFns } from "./CandidateWrapper.vue?vue&type=template&id=430bbcda&scoped=true"
import script from "./CandidateWrapper.vue?vue&type=script&lang=ts"
export * from "./CandidateWrapper.vue?vue&type=script&lang=ts"
import style0 from "./CandidateWrapper.vue?vue&type=style&index=0&id=430bbcda&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "430bbcda",
  null
  
)

export default component.exports